import React, { useMemo } from "react";
import { Box, Card, Divider, IconButton, Typography } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getIcon } from "utils/iconsConfig";
import "./clientCard.css";
import { clientBreadcrumbOptions, getClientBreadcrumbOptions } from "../../../constants/constants";
import { ReactComponent as Green_Wallet } from "assets/icons/Clients_Flow_Icons/clientCardIcons/green_wallet_icon.svg";
import { formatCurrency, formatShortAmount } from "utils/formatCurrency";

const AmountBox = ({ icon, text, color }) => (
  <div className="amount-box">
    <IconButton disableFocusRipple disableRipple sx={{ padding: 0 }}>
      {getIcon(icon)}
    </IconButton>
    <Typography className="amount-txt" sx={{ color }}>
      {text}
    </Typography>
  </div>
);

const DetailBox = ({ icon, count }) => (
  <div className="order-quote-bottom">
    <IconButton disableFocusRipple disableRipple sx={{ padding: 0 }}>
      {getIcon(icon)}
    </IconButton>
    <Typography className="order_quote-deatils">{count}</Typography>
  </div>
);

function ClientCard({ showLine = false, data = {}, pageType }) {
  const navigate = useNavigate();
  const location = useLocation();

  const isCatalogPage = location.pathname.includes("clients-catalog");
  const params = useParams();

  const { bg, name, count, icon, details = [], amount1, amount2, weight, designCount, ledgerColor } = data;
  const hasAmounts = amount1 || amount2;
  const hasDetails = details.length > 0;

  const dropdownOptions = getClientBreadcrumbOptions(params);

  const page = pageType;
  const filterPath = useMemo(() => name?.split(" ").join("-"), [name]);
  const activeOption = useMemo(() => {
    for (const sectionName in dropdownOptions) {
      const section = dropdownOptions[sectionName];
      const foundOption = section.options.find((opt) => {
        const lastSegment = opt.path.split("/").pop().toLowerCase();
        return lastSegment === filterPath.toLowerCase();
      });
      if (foundOption) {
        return foundOption;
      }
    }
    return null;
  }, [dropdownOptions, filterPath]);
  let state = activeOption?.state || {};
  const handleNavigate = () => {
    const newState = {
      ...state,
      isActiveCatalog: filterPath === "Active-Catalog",
    };
    navigate(`${filterPath}`, { state: newState });
  };

  return (
    <Card sx={{ background: bg || "#191818" }} className={name === "Dues" ? "dues-card" : name === "Ledger" ? "ledger-card" : ""}>
      <Box className="card-container" onClick={handleNavigate}>
        {/* ---------- TOP SECTION ---------- */}
        {hasAmounts && (
          <Box className="ledger-container-top" sx={{ gap: "6px" }}>
            <IconButton disableFocusRipple disableRipple sx={{ padding: 0 }}>
              {getIcon(icon)}
            </IconButton>
            <Typography className="card-title">{name} -</Typography>
            <Typography className="card-designcount">{count}</Typography>
          </Box>
        )}

        {!hasAmounts && hasDetails && (
          <Box className="order-quote-top">
            <Typography className="card-title">{name}</Typography>
            <Box sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
              {page === "wip" && <IconButton sx={{ padding: 0 }}>{getIcon(icon)}</IconButton>}
              <Typography className={page === "wip" ? "wip-top-count" : "order-quote-top-count"}>{count}</Typography>
            </Box>
          </Box>
        )}

        {!hasAmounts && !hasDetails && (
          <Box className="card-content-1">
            <Typography className="card-title">{name}</Typography>
          </Box>
        )}

        {showLine && <Divider sx={{ width: "100%", border: "0.5px solid #3A3A3A", margin: "10px 0" }} />}

        {/* ---------- BOTTOM SECTION ---------- */}
        {hasAmounts && (
          <Box className="ledger-container-bottom">
            {name === "Dues" ? (
              <>
                <Box className="amount-col">
                  {/* <Typography className="amount-value">
                    {formatCurrency(amount1)}
                    <span className="amount-short"> ({formatShortAmount(amount1)})</span>
                  </Typography> */}
                   <Typography className="amount-value green">{amount1}({formatShortAmount(amount1)})</Typography>
                   {/* <Typography className="amount-value green">({formatShortAmount(amount1)})</Typography> */}
                  <Typography className="amount-label">Billed Dues</Typography>
                </Box>

                <Box className="amount-col">
                  <Typography className="amount-value green">{amount2}({formatShortAmount(amount2)})</Typography>
                  <Typography className="amount-label">Current Dues</Typography>
                </Box>

                <Box className="amount-col">
                  <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                    {getIcon("GoldBar")}
                    <Typography className="amount-value">{formatShortAmount(weight)} g</Typography>
                  </Box>
                  <Typography className="amount-label">Unfix Gold</Typography>
                </Box>
              </>
            ) : (
              <>
                <Typography className="amount-label">Closing Balance :</Typography>

                <Box className="amount-box">
                  {getIcon(ledgerColor === "#E77B7B" ? "Red_Wallet" : "Green_Wallet")}
                  <Typography className="amount-value" sx={{ color: ledgerColor }}>
                    {amount2}({formatShortAmount(amount2)})
                  </Typography>
                </Box>
              </>
            )}
          </Box>
        )}

        {!hasAmounts && hasDetails && (
          <Box className="order-quote-bottom-parent">
            {details.map((obj, idx) => (
              <DetailBox key={idx} icon={obj.icon} count={obj.count} />
            ))}
          </Box>
        )}

        {!hasAmounts && !hasDetails && (
          <Box className="card-content-2">
            <IconButton disableFocusRipple disableRipple>
              {getIcon(icon)}
            </IconButton>
            <Typography className="card-designcount">{count}</Typography>

            {(isCatalogPage || designCount > 0) && <Typography className="card-designcount-2">({designCount} Design)</Typography>}
          </Box>
        )}
      </Box>
    </Card>
  );
}

export default ClientCard;
